import React from "react";
import { Link } from "react-router-dom";
import { Section, Card } from "../elements/bodyComponents";
import { ShuffleArray } from "../helpers/helpers";
import { Button } from "../elements/buttons";
import { SectionTitle } from "../typography/typography";
import { BuildImagePath } from "../helpers/helpers";

//DATA
import { Recipes } from "../json/recipes";

/*
    RECIPE PROMO - used to display a few recipes
*/
export class RecipePromo extends React.Component {
  constructor(props) {
    super(props);

    this.getRecipes = this.getRecipes.bind(this);
    this.state = {
      recipes: this.getRecipes(this.props)
    };
  }

  getRecipes(props) {
    //console.log( 'get recipes for', this.props.category );
    let recipes = [];
    if (props.category === "featured") {
      recipes = Recipes.filter(r => {
        return r.featured === true;
      });
    } else {
      recipes = Recipes.filter(r => {
        return r.category === props.category;
      });
    }

    //if generating related recipes remove current recipe from options
    if (typeof props.currentRecipe !== "undefined") {
      console.log("removing", props.currentRecipe, "from the possible options");
      recipes = recipes.filter(r => r.id !== props.currentRecipe);
    }

    //if greater than max number - reduce
    if (recipes.length > props.max) {
      let shuffledArray = ShuffleArray(recipes);
      recipes = shuffledArray.slice(0, props.max);
    }

    return this.buildRecipeCards(recipes, props.color);
  }

  /*
        Build Card Components
        called by getRecipes after recipes are determined.
    */
  buildRecipeCards(recipes, color) {
    return recipes.map(r => (
      <RecipeCard
        maxNumRecipes={this.props.max}
        key={r.id}
        id={r.id}
        color={color}
        title={typeof r.shortname !== "undefined" ? r.shortname : r.name}
        description={r.description}
        image={r.image}
      />
    ));
  }

  /*
        called when new params are passed to the component, like changing between recipes
    */
  componentWillReceiveProps(nextProps) {
    this.setState({
      recipes: this.getRecipes(nextProps)
    });
  }

  render() {
    let classes = this.props.classes;
    if (typeof classes === "undefined") {
      classes = "";
    }

    return (
      <Section
        classes={`recipesPromo gridStyle-layout padding-y-xlarge ${classes}`}
      >
        {typeof this.props.title !== "undefined" && (
          <SectionTitle classes="recipesPromo-title text-align-center margin-bottom-medium">
            <span>{this.props.title}</span>
          </SectionTitle>
        )}
        <div className="section-inner flex">{this.state.recipes}</div>
        <div className="section-actions text-align-center margin-top-large">
          <Link to={this.props.URL}>
            <Button
              classes="primary"
              color={
                typeof this.props.color !== "undefined"
                  ? this.props.color
                  : "yellow"
              }
              text="All Recipes"
            />
          </Link>
        </div>
      </Section>
    );
  }
}

export class RecipeCard extends React.Component {
  render() {
    const max = 90;
    let truncatedDescription = this.props.description;
    if (truncatedDescription.length > max) {
      truncatedDescription = truncatedDescription.substr(0, max);
      truncatedDescription = truncatedDescription.substr(
        0,
        Math.min(
          truncatedDescription.length,
          truncatedDescription.lastIndexOf(" ")
        )
      );
      truncatedDescription = truncatedDescription + "...";
    }

    let type = "product";
    if (typeof this.props.type !== "undefined") {
      type = this.props.type;
    }

    let color = "yellow";
    if (typeof this.props.color !== "undefined") {
      color = this.props.color;
    }

    let imageSizeArray = [
      {
        w: 480,
        name: "small"
      },
      {
        w: 700,
        name: "medium"
      },
      {
        w: 800,
        name: "small"
      },
      {
        w: 4000,
        name: "medium"
      }
    ];

    if (this.props.maxNumRecipes === "4") {
      imageSizeArray = [
        {
          w: 480,
          name: "small"
        },
        {
          w: 700,
          name: "medium"
        },
        {
          w: 1100,
          name: "small"
        },
        {
          w: 4000,
          name: "medium"
        }
      ];
    }

    return (
      <Card
        type={type}
        category={"recipes"}
        title={this.props.title}
        desc={truncatedDescription}
        color={color}
        classes="flex-equalSize text-align-center"
        image={BuildImagePath(this.props.image, "recipes", imageSizeArray)}
        link={`/recipes/${this.props.id}`}
        button={{
          size: "textOnly arrowRight",
          text: "Get Recipe"
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/recipes.js